const constants = {
  apiHost: process.env.VUE_APP_apiHost,
  domain: process.env.VUE_APP_domain,
  cookieScope: process.env.VUE_APP_cookieScope,
  url: process.env.VUE_APP_url,
  s3Bucket: process.env.VUE_APP_s3Bucket,
  parserAPI: process.env.VUE_APP_parserAPI,
  personalityAPI: process.env.VUE_APP_personalityAPI,
  loginServiceUrl: process.env.VUE_APP_loginServiceUrl,
  acticsServiceUrl: process.env.VUE_APP_acticsServiceUrl,
  commServiceUrl: process.env.VUE_APP_commServiceUrl,
  feedServiceUrl: process.env.VUE_APP_feedServiceUrl,
  connServiceUrl: process.env.VUE_APP_connServiceUrl,
  paymentsServiceUrl: process.env.VUE_APP_paymentsServiceUrl,
  coachServiceUrl: process.env.VUE_APP_coachServiceUrl,
  hibobIntegrationServiceUrl: process.env.VUE_APP_hibobIntegrationServiceUrl,
  platformServiceUrl: process.env.VUE_APP_platformServiceUrl,
  coachIntegrationServiceUrl: process.env.VUE_APP_coachIntegrationServiceUrl,
  parserFeedbackApi: process.env.VUE_APP_parserFeedbackApi,
  gatewayServiceUrl: process.env.VUE_APP_gatewayServiceUrl,
  marketAdminUrl: process.env.VUE_APP_marketAdminUrl,
  castUrl: process.env.VUE_APP_castApi,
  roomUrl: process.env.VUE_APP_roomUrl,
  coreAPI: process.env.VUE_APP_coreApi,
  resumeparserAPI: process.env.VUE_APP_API_URL
};

export default constants;
